import { IStackTokens, Stack, Image, ImageFit, Label, FontIcon } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../../styles/collectie.module.scss';
import { TProduct, TSize } from '../../constants/types';
import { GetProducts, GetProduct } from '../../services/GSAPI';
import { generateProductUrl, generateSetUrl, ProcessProducts } from '../../helpers/General';
import { AlertButtonComponent } from '../../components/alertButtonComponent';
import PulseLabelv2 from '../../components/pulseLabelv2Component';
import { NavLink } from 'react-router-dom';
import GlobalContext from '../../_contexts/GlobalContext';
import { Helmet } from 'react-helmet';
import ImageViewerSplashContext from '../../_contexts/ImageViewerContext';

export interface IProductViewerComponentProps {
    allProducts: TProduct[];
    onBuyClick: Function;
    cards: TProduct[];
    EurPrice: number;
    SatPrice: number;
    AlertCoachmarkVisible: boolean;
    SetSelectedProductForAlert?: Function;
    onImageClick: Function;
    ShowToast: Function;
    SetSelectedSet?: Function;
}

const ProductViewerComponent: React.FunctionComponent<IProductViewerComponentProps> = (props: IProductViewerComponentProps) => {
    const [product, setproduct] = useState<TProduct>();
    const [added, setadded] = useState<boolean>();
    const [notAdded, setnotAdded] = useState<boolean>();
    const [nextProduct, setNextProduct] = useState<TProduct>();
    const [prevProduct, setPrevProduct] = useState<TProduct>();
    const [setProducts, setSetProducts] = useState<TProduct[]>();
    const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);
    const [reloadTrigger, setReloadTrigger] = useState<number>();
    const [startSwipe, setStartSwipe] = useState<number>(-1);
    const [endSwipe, setEndSwipe] = useState<number>(-1);

    const { SetToastMessage, Strings, BitcoinEnabled, DevEnabled, GlobalImagesVersion, windowSize } = useContext(GlobalContext);
    const { setImgUrls } = useContext(ImageViewerSplashContext);

    const [pictureInfoVisible, setpictureInfoVisible] = useState<boolean>(false);
    const [mouseX, setmouseX] = useState<number>();
    const [mouseY, setmouseY] = useState<number>();

    useEffect(() => {
        if (product) {
            
        }
    },[]);

    useEffect(() => {
        const pathName = decodeURI(window.location.pathname);
        const prodName = pathName.substring(1, pathName.length);
        const parts = prodName.split('/');
        const type = parts[0];
        if (type.toLowerCase() === "product") {
            const setPTitlePIDparts = parts[parts.length-1].split(" - ");
            const setname = setPTitlePIDparts[0];
            const productid = setPTitlePIDparts[setPTitlePIDparts.length-1];

            GetProduct(productid, DevEnabled).then(products => {
                if (products.length > 0) {
                    products.forEach(product => {
                        let imageUrls: string[] = [];
                        product.imageNames.split(',').forEach(imageName => {
                            imageUrls.push(`${process.env.PUBLIC_URL}/assets/products/${product.setID}/${product.id.toString()}/${imageName}?v=${GlobalImagesVersion}`);
                        });
                        product.name = setname;
                        product.imageUrls = imageUrls;
                        setproduct(product);
                        GetPrevAndNextProduct(product);
                    });
                } else {
                    //window.location.href = window.location.origin;
                }
            }).catch(err => {
                console.log(err);
            });
        }
            
    },[reloadTrigger]);

    function swipeEnd(e) {
        if (startSwipe != -1 && endSwipe != -1) {
            if ((endSwipe - startSwipe) > 20) {
                selectedImageIndex > 0 ? setSelectedImageIndex(selectedImageIndex-1) : setSelectedImageIndex(product.imageUrls.length -1);
            } else if ((startSwipe - endSwipe) > 20) {
                selectedImageIndex+1 < product.imageUrls.length ? setSelectedImageIndex(selectedImageIndex+1) : setSelectedImageIndex(0);
            }
            setStartSwipe(-1);
            setEndSwipe(-1);
        }
    }

    function GetPrevAndNextProduct(product: TProduct) {
        let nextProduct : TProduct;
        let prevProduct : TProduct;
        
        GetProducts(product.setID, true, DevEnabled).then(_products => {
            const products = ProcessProducts(_products);
            setSetProducts(products);

            for (let i=0; i<products.length; i++) {
                if (products[i].id === product.id) {
                    nextProduct = products[i+1];
                    if (i>0) {
                        prevProduct = products[i-1];
                    }
                }
            }

            setNextProduct(nextProduct);
            setPrevProduct(prevProduct);
        }).catch(err => {
            console.log(err);
        });
    }

    function tryAddToChart(card: TProduct) {
        let done = false;
        if (card.available > 0) {
            done = props.onBuyClick(card);
        }
        if (done) {
            setadded(true);
            setTimeout(() => {
                setadded(false);
            }, 500);
        } else {
            SetToastMessage("Niet meer beschikbaar");
            setnotAdded(true);
            setTimeout(() => {
                setnotAdded(false);
            }, 500);
        }
    }

    function SetSelectedSet() {
        props.SetSelectedSet(product.setID);
    }

    function onNavMouseMove(e) {
        setmouseX(e.clientX-110);
        setmouseY(e.clientY-50);
    }

    return (
        product && 
        <div className={`${styles.mainDiv} `} style={{ maxWidth: "100%", paddingLeft: 10, overflow: "hidden", marginRight: 5 }} >
            <Helmet>
                <title>{`${product.name} ${product.title}`}</title>
            </Helmet>
            <Stack horizontalAlign='start' horizontal={windowSize.x > 650 ? true : false}>
                <Stack horizontalAlign='center' 
                       className={styles.sPanel} 
                       style={{ marginRight: windowSize.x > 650 ? 4 : 0, width:"100%" }} >
                    {window.innerWidth >= 960 && <div style={{display:pictureInfoVisible?"block":"none", top:mouseY, left:mouseX}} className={`${styles.imageClickForHighRez} ${pictureInfoVisible ? styles.fadeIn : ""}`}>Click om te vergroten</div>}
                    <Image {...{className:styles.singleImage,
                                onTouchStart: (e) => { setStartSwipe(e.targetTouches[0].clientX); },
                                onTouchMove: (e) => { setEndSwipe(e.targetTouches[0].clientX); },
                                onTouchEnd: swipeEnd,
                                onMouseMove: onNavMouseMove,
                                onMouseOver: () => { setpictureInfoVisible(true); }, 
                                onMouseLeave: () => { setpictureInfoVisible(false); },
                                onClick:() => { windowSize.x >= 960 ? setImgUrls(product.imageUrls) : null;},
                                onError:(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = `${process.env.PUBLIC_URL}/assets/NoImgFound.webp`
                                },
                                src: `${process.env.PUBLIC_URL}${product.imageUrls[selectedImageIndex]}`}}/>
                    <Stack horizontalAlign='center' horizontal verticalAlign='center'>
                        <FontIcon aria-label="Vorige" className={styles.prevNextIcon} onClick={() => {selectedImageIndex > 0 ? setSelectedImageIndex(selectedImageIndex-1) : setSelectedImageIndex(product.imageUrls.length -1)}} iconName="ChevronLeft" />
                        {selectedImageIndex+1} / {product.imageUrls.length} 
                        <FontIcon aria-label="Volgende" className={styles.prevNextIcon} onClick={() => {selectedImageIndex+1 < product.imageUrls.length ? setSelectedImageIndex(selectedImageIndex+1) : setSelectedImageIndex(0)}} iconName="ChevronRight" />
                    </Stack>
                </Stack>
                <Stack style={{width:"100%"}}>
                    <Stack className={styles.sPanel} horizontal horizontalAlign='center' style={{backgroundColor:'aliceblue'}}>
                        <span style={{ overflow: "hidden", fontSize: "x-large", marginTop: 10, color: "black", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{product.title}</span>
                    </Stack>
                    <div style={{ width: "100%", paddingBottom: 5, paddingTop: 5 }}>
                        <Stack horizontal horizontalAlign='center' className={styles.aPanel}>
                            <Stack horizontalAlign='start' style={{ paddingTop: 5, width:"100%" }}>
                                {prevProduct && <NavLink to={generateProductUrl(prevProduct)} onClick={() => { setReloadTrigger(Date.now())}}>
                                    {/* <Stack horizontalAlign='center' style={{paddingRight:10,paddingBottom:5}}>
                                        <Label style={{ textDecoration: "none" }}>Vorige</Label>
                                    </Stack> */}
                                    <Image className={styles.setPrevNextMenuSingle} src={window.location.origin + prevProduct.imageUrls[0]} alt={product.name} />
                                </NavLink>}
                            </Stack>
                            <NavLink to={generateSetUrl(product)}>
                                <Stack onClick={SetSelectedSet} horizontalAlign='center' verticalAlign='center' style={{ paddingBottom: 20, width: (windowSize.x-60)/3, height:"100%" }}>
                                    <Image className={styles.setLogoMenuSingle} 
                                           style={{maxWidth: 160}} 
                                           src={process.env.PUBLIC_URL + `/assets/products/${product.setID.toString()}/${product.setID.toString()}.webp?v=${GlobalImagesVersion}`} 
                                           alt={product.name} />
                                    <Label style={{ textDecoration: "none" }}>Ga naar set</Label>
                                </Stack>
                            </NavLink>
                            <Stack horizontalAlign='end' style={{ paddingTop: 5, width:"100%" }}>
                                {nextProduct && <NavLink to={generateProductUrl(nextProduct)} onClick={() => { setReloadTrigger(Date.now())}}> 
                                    {/* <Stack horizontalAlign='center' style={{paddingRight:10,paddingBottom:5}}>
                                        <Label style={{ textDecoration: "none" }}>Volgende</Label>
                                    </Stack> */}
                                    <Image className={styles.setPrevNextMenuSingle} src={window.location.origin + nextProduct.imageUrls[0]} alt={product.name} />
                                </NavLink>}
                            </Stack>
                        </Stack>
                    </div>
                    <div className={`${styles.divTable}, ${styles.sPanel}`} style={{ verticalAlign: 'start', width: "100%", height: "100%", whiteSpace: "nowrap" }}>
                        <div className={styles.divTableRow}>
                            <div className={styles.divTableCell}>
                                <Label className={styles.generalLabel}>&nbsp;Naam</Label>
                            </div>
                            <div className={styles.divTableCell} style={{ paddingLeft: 10 }}>
                                
                            </div>
                            <div className={styles.divTableCell}>
                                <Label className={styles.infoLabel}>{product.title}</Label>
                            </div>
                        </div>
                        {product.tags.map(tag => {
                            return <div className={styles.divTableRow}>
                                    <div className={styles.divTableCell}>
                                        <Label className={styles.generalLabel}>&nbsp;{tag.key}</Label>
                                    </div>
                                    <div className={styles.divTableCell} style={{ paddingLeft: 10 }}>
                                        
                                    </div>
                                    <div className={styles.divTableCell}>
                                        {tag.value === '1' || tag.value === '0' ? <Label className={styles.infoLabel}>{tag.value  === '1' ? "Ja" : "Nee"}</Label>
                                                                                : <Label className={styles.infoLabel}>{tag.value ? tag.value : "Onbekend"}</Label>}
                                    </div>
                                   </div>
                        })}

                        <div className={styles.divTableRow}>
                            <div className={styles.divTableCell}>
                                
                            </div>
                            <div className={styles.divTableCell} style={{ paddingLeft: 10 }}>

                            </div>
                            <div className={styles.divTableCell}>
                                <div style={{whiteSpace:"normal"}}>{product.description.split('\n').map((line) => {
                                    return <>
                                        <span className={styles.generalLabel}>{line}</span><br/>
                                    </>
                                })}</div>
                            </div>
                        </div>  
                    </div>
                    
                    <div className={`${styles.divTable}, ${styles.sPanel}`} style={{ backgroundColor: 'aliceblue', verticalAlign: 'start', width: "100%", whiteSpace: "nowrap" }}>
                        <div className={styles.divTableRow}>
                            <div className={styles.divTableCell} style={{ width: "100%" }}>

                            </div>
                            <div className={styles.divTableCell} style={{ paddingLeft: 10, verticalAlign: "middle" }}>
                                <Stack style={{ paddingTop: 1 }} verticalAlign='center' horizontal>
                                    {BitcoinEnabled && <Stack horizontal>
                                        <Image className={styles.btcicon}
                                            style={{ cursor: "default" }}
                                            src={`${process.env.PUBLIC_URL}/assets/btcicon.png`}
                                        />
                                        <PulseLabelv2 style={{ color: 'rgb(70, 65, 65)' }} text={`${product.priceInEUR === 0 ? "-" : Math.round(product.priceInUSD / props.SatPrice)} sats`} />
                                    </Stack>}
                                
                                    <PulseLabelv2 style={{ paddingRight:10, color: 'rgb(70, 65, 65)' }} text={`€ ${product.priceInEUR === 0 ? "---.--" : product.priceInEUR.toFixed(2)}`} />
                                    {product.priceInEUR != 0 && product.available > 0 ?
                                        <FontIcon style={{ width: 100, height: "100%", fontSize: 25, backgroundColor: "#30a7d7" }}
                                            aria-label={Strings?.AddToCart}
                                            onClick={() => { tryAddToChart(product); }}
                                            className={`${styles.buyButtonSingle} ${added ? styles.added : notAdded ? styles.notAdded : ""}`}
                                            iconName={added ? "ShoppingCartSolid" : "ShoppingCart"} />
                                        :
                                        <AlertButtonComponent Visible={props.AlertCoachmarkVisible} OnClick={() => { props.SetSelectedProductForAlert(product); }} />
                                    }
                                </Stack>
                            </div>
                        </div>
                    </div>
                </Stack>
            </Stack>
        </div>
    );
}

export default ProductViewerComponent;